<div class="main-container">
  <div class="score-tooltip-drilldownChart" [ngStyle]="{left: tooltipX + 'px', top: tooltipY + 'px', display: tooltipVisible}">
    <div class="tooltipHeading">{{event.label}}</div>
    <div>
      <div class="caret border-bottom">
        <div class="tooltipLabel">Responses</div> 
        <div class="tooltipValue">{{ event.response }}</div> 
      </div>
      <div class="caret border-bottom">
        <div class="tooltipLabel">{{ event.ratingName }}</div> 
        <div class="tooltipValue">{{ event.rating }}</div> 
      </div>
      <div class="caret" *ngFor="let dataPoint of event?.dataPoints; let last = last" [ngClass]="{'border-bottom': !last}">
        <div class="tooltipLabel">{{ dataPoint.label }}</div> 
        <div class="tooltipValue">{{ dataPoint.value }}</div> 
      </div>
    </div>
  </div>
  <div class="chart-container" #chartContainer [style.min-height.px]="chartContainerHeight" [style.max-height.px]="chartContainerHeight">
    <div class="colSmall">
      <canvas [id]="uniqueId2" height="100%"></canvas>
    </div>
    <div class="colLarge" id="box">
      <div class="box" [style.width]="calcWidth()">
        <canvas [id]="uniqueId1" height="100%"></canvas>
      </div>
    </div>
  </div>
  <div class="custom-legend-container">
    <div class="cohort-labels">{{ data.xText }}</div>
    <div class="custom-legend">
      <div class="custom-legend-item" *ngFor="let dataset of data.datasets; let i = index" (click)="toggleDatasetVisibility(i)" [ngClass]="{
        'selected': selectedDatasetIndex === i,
        'deselected': selectedDatasetIndex !== null && selectedDatasetIndex !== i,
        'underlined': selectedDatasetIndex === null
      }"
      [style.cursor]="data.datasets.length > 1 ? 'pointer' : 'default'">
        <div class="color-box" [style.background-color]="dataset.backgroundColor"></div>
        <div class="label" [ngClass]="{
          'selected': selectedDatasetIndex === i,
          'deselected': selectedDatasetIndex !== null && selectedDatasetIndex !== i,
          'underlined': selectedDatasetIndex === null
        }">{{ dataset.label }}</div>
      </div>
    </div>
  </div>
</div>